<template>
  <div class="app-breadcrumb p-mb-2 px-3" role="navigation" :aria-label="$t('breadcrumb.aria')">
    <Breadcrumb :home="home" :model="items" />
  </div>
</template>

<script>
import Breadcrumb from 'primevue/breadcrumb';

export default {
  name: 'BreadcrumbComponent',
  components: { Breadcrumb },
  data() {
    return {
      home: {
        icon: 'pi pi-home',
        to: '/',
      },
      items: [],
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.items = this.buildItems(this.$route);
      },
    },
  },
  methods: {
    routeBreadcrumbLabel(routeName) {
      const k = `routes.${String(routeName)}.breadcrumb`;
      if (this.$te(k)) return this.$t(k);
      const kTitle = `routes.${String(routeName)}.title`;
      if (this.$te(kTitle)) return this.$t(kTitle);
      return this.$t('breadcrumb.pageFallback');
    },
    buildItems(route) {
      const name = route.name;
      const meta = route.meta || {};
      const label = this.routeBreadcrumbLabel(name) || meta.title || meta.name || this.$t('breadcrumb.pageFallback');
      const list = [];

      if (name === 'producto') {
        list.push({
          label: this.$t('breadcrumb.catalog'),
          to: '/catalogo-productos',
        });
        list.push({ label, to: route.path });
        return list;
      }

      if (name === 'publicacion') {
        list.push({ label, to: route.path });
        return list;
      }

      if (name === 'catalogo-amazon') {
        list.push({ label, to: route.path });
        return list;
      }

      if (name === 'CatalogoProductos') {
        list.push({ label, to: route.path });
        return list;
      }

      if (
        [
          'nosotros',
          'Contacto',
          'TrabajaConNosotros',
          'NotFound',
          'ValidarCarrito',
          'FinalizarCompra',
          'GraciasCompra',
          'LoginTienda',
          'RegistroUsuario',
          'RecuperarContrasena',
          'PerfilUsuario',
          'historia-destacados',
        ].includes(name)
      ) {
        list.push({ label, to: route.path });
      }

      return list;
    },
  },
};
</script>

<style scoped>
.app-breadcrumb {
  text-align: left;
  max-width: 1400px;
  margin: 0 auto;
  padding-top: 0.35rem;
  border-top: 1px solid rgba(201, 169, 98, 0.12);
}
</style>
